import { useEffect, useState } from "react";
import {
    FaMapMarkerAlt,
    FaWifi,
    FaTv,
    FaExpand,
    FaWhatsapp,
    FaPhone,
    FaBath,
    FaInfoCircle,
    FaHotTub,
    FaCalendarAlt,
    FaClock,
    FaLock,
    FaBuilding,
    FaVenusMars,
    FaCouch,
    FaUtensils,
    FaCar,
} from "react-icons/fa";
import {
    MdBalcony,
    MdClose,
    MdKeyboardArrowLeft,
    MdKeyboardArrowRight,
} from "react-icons/md";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import axios from "axios";
import Config, { inventoryBelongsTo } from "../../Config";
import { useSelector } from "react-redux";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { capitalizeFirstLetter } from "../../helpers";

const PropertyDetail = () => {
    const { id: propId } = useParams();//12034
    const [showAllPhotos, setShowAllPhotos] = useState(false);
    const [fullScreenImageIndex, setFullScreenImageIndex] = useState(0);
    const [apiData, setApiData] = useState(null)
    const [allImages, setAllImages] = useState([]);

    const DUMMY_PROPERTY_IMAGE = Images.DummyProperty;

    const fetchFunction = async () => {

        const response = await axios.get(
            `${Config.apiUrl}/inventory/share/${propId}`,
            {
                headers: {
                    // authorization: `Bearer ${user.token}`,
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        setApiData(res?.data);
        const images = res?.data?.media?.flatMap(item => item.images) || [];
        setAllImages(images);  // store in state
    };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
    });

    useEffect(() => {
        getListMutate();
    }, []);

    const handleFullScreenNavigation = (direction) => {
        if (direction === "prev") {
            setFullScreenImageIndex((prev) =>
                prev === 0 ? allImages.length - 1 : prev - 1,
            );
        } else {
            setFullScreenImageIndex((prev) =>
                prev === allImages.length - 1 ? 0 : prev + 1,
            );
        }
    };

    const foodPreferenceMap = {
        1: "Veg",
        2: "Non-Veg",
        3: "Whatever",
    };

    const furnishingTypeMap = {
        1: "Fully Furnished",
        2: "Semi Furnished",
        3: "Unfurnished",
    };

    const tenantPreferenceMap = {
        1: "Family",
        2: "Bachelor",
        3: "Company Lease",
        4: "Any",
    };

    const inventoryTypeMap = {
        1: "Independent Floor/Villa",
        2: "Apartment/Flat",
        4: "PG",
        5: "Showroom/Shop",
        6: "Office Space",
    };

    const listingTypeMap = {
        1: "Rent",
        2: "Sale",
        3: "Lease",
    };

    const inventorySubTypeMap = {
        1: "1 RK",
        2: "Studio",
        3: "1",
        4: "1.5",
        5: "2",
        6: "2.5",
        7: "3",
        8: "3.5",
        9: "4",
        10: "4.5",
        11: "5",
        12: "6",
        13: "7",
        14: "8",
        15: "9",
    };

    const inventoryAgeMap = {
        NEW: "New",
        "1Y": "1 Year Old",
        "2Y": "2 Years Old",
        "3Y_PLUS": "3+ Years Old",
    };

    const parkingMap = {
        0: "No Parking",
        1: "Bike Parking",
        2: "Car Parking",
        3: "Bike & Car",
    };

    // const bathroomTypeMap = {
    //     1: "Attached",
    //     2: "Common",
    //     3: "Both",
    // };

    const PROPERTY_FEATURES = {
        0: "Bus Stop",
        1: "Railway Station",
        2: "Airport",
        3: "Hospital",
        4: "Temple",
        5: "Grocery Store",
        6: "Power Backup",
        7: "Lift",
        8: "Club House",
        9: "Gym",
        10: "Swimming Pool",
        11: "Library",
        12: "Children Play Area",
        13: "Gated Community",
        14: "24×7 Security",
        15: "Fire Fighting System",
        16: "Smoke Detector",
        17: "Pet Friendly",
    };

    const totalMoveIn =
        Number(apiData?.amount || 0) +
        Number(apiData?.deposit || 0) +
        Number(apiData?.moveInCharges || 0) +
        Number(apiData?.maintenance || 0);


    // Full Screen Modal Component
    const FullScreenModal = () => (
        <ModalOverlay>
            <CloseButton onClick={() => setShowAllPhotos(false)}>
                <MdClose size={20} />
            </CloseButton>

            <ModalContent onClick={(e) => e.stopPropagation()}>
                <ImageContainer>
                    <FullScreenImage
                        src={
                            allImages?.length > 0
                                ? allImages[fullScreenImageIndex]
                                : DUMMY_PROPERTY_IMAGE
                        }
                        alt={`Inventory ${fullScreenImageIndex + 1}`}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = DUMMY_PROPERTY_IMAGE;
                        }}
                    />

                    <NavButton
                        className="left-2 sm:left-4"
                        onClick={() => handleFullScreenNavigation("prev")}
                    >
                        <MdKeyboardArrowLeft size={24} />
                    </NavButton>

                    <NavButton
                        className="right-2 sm:right-4"
                        onClick={() => handleFullScreenNavigation("next")}
                    >
                        <MdKeyboardArrowRight size={24} />
                    </NavButton>

                    <ImageCounter>
                        Image {fullScreenImageIndex + 1} of {allImages.length}
                    </ImageCounter>
                </ImageContainer>

                <ThumbnailStrip>
                    {allImages.map((img, idx) => (
                        <ThumbnailButton
                            key={idx}
                            onClick={() => setFullScreenImageIndex(idx)}
                            className={
                                idx === fullScreenImageIndex
                                    ? "border-blue-500 ring-2 ring-blue-200"
                                    : "border-gray-600 hover:border-gray-400"
                            }
                        >
                            <img
                                src={img}
                                alt={`Thumbnail ${idx + 1}`}
                                className="w-full h-full object-cover"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = DUMMY_PROPERTY_IMAGE;
                                }}
                            />
                        </ThumbnailButton>
                    ))}
                </ThumbnailStrip>
            </ModalContent>
        </ModalOverlay>
    );

    const overviewItems = [
        {
            icon: FaUtensils,
            label: "Food Preference",
            value: foodPreferenceMap[apiData?.foodPreference],
        },
        {
            icon: FaCouch,
            label: "Furnishing",
            value: furnishingTypeMap[apiData?.furnishingType],
        },
        {
            icon: FaBuilding,
            label: "Property Type",
            value: inventoryTypeMap[apiData?.inventoryType],
        },
        {
            icon: FaVenusMars,
            label: "Tenant Type",
            value: tenantPreferenceMap[apiData?.tenantPreference],
        },

        // 🔥 NEW CONDITIONAL FIELDS
        {
            icon: FaExpand,
            label: "Carpet Area",
            value: apiData?.carpetArea ? `${apiData.carpetArea} sq.ft` : null,
        },
        {
            icon: FaExpand,
            label: "Built-up Area",
            value: apiData?.buildUpArea ? `${apiData.buildUpArea} sq.ft` : null,
        },
        {
            icon: FaBuilding,
            label: "Total Floors",
            value: apiData?.totalFloors,
        },
        {
            icon: MdBalcony,
            label: "Balconies",
            value: apiData?.noOfBalcony,
        },
        {
            icon: FaBath,
            label: "Bathrooms",
            value: apiData?.noOfBathroom,
        },
        {
            icon: FaCar, // import this
            label: "Parking",
            value: parkingMap[apiData?.parking],
        },
        {
            icon: FaCalendarAlt,
            label: "Property Age",
            value: inventoryAgeMap[apiData?.age],
        },
    ];

    if (isLoading) {
        return (
            <Container>

                {/* Header */}
                <Header>
                    <HeaderContainer>
                        <div className="flex items-center gap-3">
                            <div className="w-20 h-6 bg-gray-200 rounded animate-pulse"></div>
                            <div className="hidden md:block w-24 h-4 bg-gray-200 rounded animate-pulse"></div>
                        </div>
                    </HeaderContainer>
                </Header>

                <Main>

                    {/* Title */}
                    <div className="mb-6 animate-pulse">
                        <div className="h-6 w-1/2 bg-gray-200 rounded mb-2"></div>
                        <div className="h-4 w-1/3 bg-gray-200 rounded"></div>
                    </div>

                    {/* Gallery */}
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-8 animate-pulse">
                        <div className="col-span-2 row-span-2 h-60 sm:h-80 bg-gray-200 rounded-xl"></div>
                        <div className="h-28 sm:h-40 bg-gray-200 rounded-xl"></div>
                        <div className="h-28 sm:h-40 bg-gray-200 rounded-xl"></div>
                        <div className="h-28 sm:h-40 bg-gray-200 rounded-xl"></div>
                        <div className="h-28 sm:h-40 bg-gray-200 rounded-xl"></div>
                    </div>

                    {/* Layout */}
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

                        {/* Left Content */}
                        <div className="lg:col-span-2 space-y-6">

                            {/* Section Skeleton */}
                            {[1, 2].map((_, i) => (
                                <div key={i} className="animate-pulse">
                                    <div className="h-5 w-40 bg-gray-200 rounded mb-4"></div>

                                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                        {Array.from({ length: 6 }).map((_, idx) => (
                                            <div
                                                key={idx}
                                                className="p-4 rounded-xl bg-gray-100 h-20"
                                            ></div>
                                        ))}
                                    </div>
                                </div>
                            ))}

                            {/* Features */}
                            <div className="animate-pulse">
                                <div className="h-5 w-40 bg-gray-200 rounded mb-4"></div>

                                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                                    {Array.from({ length: 6 }).map((_, idx) => (
                                        <div
                                            key={idx}
                                            className="h-10 bg-gray-100 rounded-xl"
                                        ></div>
                                    ))}
                                </div>
                            </div>

                        </div>

                        {/* Right Pricing Card */}
                        <div className="animate-pulse">
                            <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">

                                <div className="h-6 w-24 bg-gray-200 rounded mb-4"></div>

                                <div className="bg-gray-100 rounded-xl p-4 space-y-3">
                                    {Array.from({ length: 3 }).map((_, idx) => (
                                        <div key={idx} className="flex justify-between">
                                            <div className="h-3 w-20 bg-gray-200 rounded"></div>
                                            <div className="h-3 w-16 bg-gray-200 rounded"></div>
                                        </div>
                                    ))}
                                </div>

                                <div className="mt-5 flex gap-3">
                                    <div className="h-10 bg-gray-200 rounded-xl w-1/2"></div>
                                    <div className="h-10 bg-gray-200 rounded-xl w-1/2"></div>
                                </div>

                            </div>
                        </div>

                    </div>

                </Main>

            </Container>
        );
    }

    //     if (!coordinates) return null;

    //     const mapUrl = `https://www.google.com/maps?q=${coordinates.lat},${coordinates.lng}&z=15&output=embed`;

    //     return (
    //         <section className="border-t mt-12 py-5 sm:py-7">
    //             {/* Title */}
    //             <SectionTitle>
    //                 Where you'll be 
    //             </SectionTitle>

    //             {/* Map Container */}
    //             <div className="relative h-[320px] sm:h-[420px] rounded-2xl overflow-hidden shadow-xl group">

    //                 {/* MAP (iframe) */}
    //                 <iframe
    //                     src={mapUrl}
    //                     className="w-full h-full"
    //                     loading="lazy"
    //                     referrerPolicy="no-referrer-when-downgrade"
    //                     title="Map location display"
    //                 ></iframe>

    //                 {/* DARK OVERLAY */}
    //                 {/* <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition duration-500"></div> */}

    //                 {/* GLASS CARD */}
    //                 <div className="absolute bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:w-[320px] 
    //                 backdrop-blur-xl bg-white/80 border border-white/40 
    //                 rounded-xl shadow-lg p-4 transition-all duration-300 group-hover:scale-[1.02]">

    //                     <div className="flex items-start gap-3">
    //                         <div className="bg-primary-color/10 text-primary-color p-2 rounded-lg">
    //                             📍
    //                         </div>

    //                         <div>
    //                             <h4 className="font-semibold text-sm sm:text-base text-gray-800 line-clamp-1">
    //                                 {title}
    //                             </h4>

    //                             <p className="text-xs sm:text-sm text-gray-600 mt-1">
    //                                 {location}
    //                             </p>

    //                             {/* BUTTONS */}
    //                             <div className="flex gap-2 mt-3">
    //                                 <a
    //                                     href={`https://www.google.com/maps/search/?api=1&query=${coordinates.lat},${coordinates.lng}`}
    //                                     target="_blank"
    //                                     rel="noreferrer"
    //                                     className="text-xs px-3 py-1.5 bg-primary-color text-white rounded-lg font-medium hover:opacity-90 transition"
    //                                 >
    //                                     View on Maps
    //                                 </a>

    //                                 <a
    //                                     href={`https://www.google.com/maps/dir/?api=1&destination=${coordinates.lat},${coordinates.lng}`}
    //                                     target="_blank"
    //                                     rel="noreferrer"
    //                                     className="text-xs px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition"
    //                                 >
    //                                     Get Directions
    //                                 </a>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>

    //                 {/* TOP BADGE */}
    //                 <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-md px-3 py-1 rounded-lg text-xs font-semibold shadow">
    //                     📍 Prime Location
    //                 </div>
    //             </div>
    //         </section>
    //     );
    // };
    return (

        <Container>
            <Header>
                <HeaderContainer>

                    {/* Left - Logo + subtle brand */}
                    <div className="flex items-center gap-3">
                        <Logo src={Images.Logo} alt="Kipinn Logo" />

                        <span className="hidden md:block text-sm text-gray-500">
                            Verified Rentals
                        </span>
                    </div>

                    {/* Right - Actions */}
                    <HeaderActions>

                        {/* WhatsApp */}
                        <button
                            onClick={() => {
                                const phone = apiData?.postedByNumber;
                                if (!phone) return;
                                window.open(`https://wa.me/${phone}`, "_blank");
                            }}
                            className="
                                flex items-center gap-2 
                                bg-green-500 hover:bg-green-600 
                                text-white 
                                px-4 py-2 rounded-xl 
                                text-sm font-semibold 
                                shadow-sm hover:shadow-md
                                transition-all duration-200
                                "
                        >
                            <FaWhatsapp className="w-4 h-4" />
                            <span className="hidden sm:inline">WhatsApp</span>
                        </button>

                        {/* Call */}
                        <button
                            onClick={() => {
                                const phone = apiData?.postedByNumber;
                                if (!phone) return;
                                window.location.href = `tel:${phone}`;
                            }}
                            className="
                            flex items-center gap-2 
                            bg-primary-color 
                            text-white 
                            px-4 py-2 rounded-xl 
                            text-sm font-semibold 
                            shadow-sm hover:shadow-md
                            transition-all duration-200
                            "
                        >
                            <FaPhone className="w-4 h-4" />
                            <span className="hidden sm:inline">Call</span>
                        </button>

                    </HeaderActions>

                </HeaderContainer>
            </Header>
            <Main>
                {/* Title Section */}
                <div className="mb-4 sm:mb-6 relative">
                    <Title>{capitalizeFirstLetter(apiData?.inventoryName || "")}</Title>

                    <div className="flex flex-wrap items-center gap-2 mt-2 text-xs sm:text-sm text-gray-700">
                        <div className="flex items-center gap-1">
                            <FaMapMarkerAlt className="w-3 h-3 sm:w-4 sm:h-4" />
                            <LocationText>{capitalizeFirstLetter(apiData?.address || "")}</LocationText>
                        </div>
                    </div>

                    {/* <button className="absolute top-0 right-0 p-2 rounded-full hover:bg-gray-100 transition">
                    <IoMdShare className="text-xl text-gray-600 hover:text-primary-color" />
                </button> */}
                </div>

                {/* Photo Gallery */}
                <GalleryGrid>
                    <MainImageContainer>
                        {allImages?.length > 0 ? (
                            <GalleryImage
                                src={allImages[0]}
                                alt="Main"
                                onClick={() => {
                                    setFullScreenImageIndex(0);
                                    setShowAllPhotos(true);
                                }}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = DUMMY_PROPERTY_IMAGE;
                                }}
                            />
                        ) : (
                            <div
                                className="
                                w-full h-full min-h-[220px] sm:min-h-[320px]
                                rounded-xl
                                bg-gray-100
                                flex flex-col items-center justify-center
                                px-4 text-center
                            "
                            >
                                <FaBuilding className="text-3xl sm:text-5xl text-gray-400 mb-3" />
                                <p className="text-sm sm:text-base text-gray-500 font-medium">
                                    No image available
                                </p>
                                <p className="text-xs sm:text-sm text-gray-400 mt-1">
                                    Photos will appear here once uploaded
                                </p>
                            </div>
                        )}
                    </MainImageContainer>

                    {allImages?.length > 1 ? (
                        allImages.slice(1, 5).map((img, idx) => (
                            <div key={idx} className="relative">
                                <GalleryImage
                                    src={img}
                                    alt={`Gallery ${idx + 2}`}
                                    onClick={() => {
                                        setFullScreenImageIndex(idx + 1);
                                        setShowAllPhotos(true);
                                    }}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = DUMMY_PROPERTY_IMAGE;
                                    }}
                                />

                                {idx === 3 && allImages.length > 5 && (
                                    <ShowAllPhotosButton
                                        onClick={() => {
                                            setFullScreenImageIndex(0);
                                            setShowAllPhotos(true);
                                        }}
                                    >
                                        <FaExpand className="w-3 h-3 sm:w-4 sm:h-4" />
                                        Show all photos
                                    </ShowAllPhotosButton>
                                )}
                            </div>
                        ))
                    ) : (
                        <>
                            {[1, 2, 3, 4].map((_, idx) => (
                                <div
                                    key={idx}
                                    className="
                                        hidden sm:flex
                                        bg-gradient-to-br from-gray-50 to-gray-100
                                        rounded-lg
                                        border border-gray-100
                                        min-h-[120px]
                                        items-center
                                        justify-center
                                        text-center
                                        px-3
                                    "
                                >
                                    <div className="flex flex-col items-center">
                                        <FaBuilding className="text-gray-300 text-lg mb-2" />
                                        <p className="text-xs font-medium text-gray-500">
                                            No image available
                                        </p>
                                        <p className="text-[10px] text-gray-400 mt-1 leading-tight">
                                            Photos will appear here once uploaded
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </>
                    )}

                    {/* {allImages?.length > 1 &&
                        allImages.slice(1, 5).map((img, idx) => (
                            <div key={idx} className="relative">
                                <GalleryImage
                                    src={img}
                                    alt={`Gallery ${idx + 2}`}
                                    onClick={() => {
                                        setFullScreenImageIndex(idx + 1);
                                        setShowAllPhotos(true);
                                    }}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = DUMMY_PROPERTY_IMAGE;
                                    }}
                                />

                                {idx === 3 && allImages.length > 5 && (
                                    <ShowAllPhotosButton
                                        onClick={() => {
                                            setFullScreenImageIndex(0);
                                            setShowAllPhotos(true);
                                        }}
                                    >
                                        <FaExpand className="w-3 h-3 sm:w-4 sm:h-4" />
                                        Show all photos
                                    </ShowAllPhotosButton>
                                )}
                            </div>
                        ))} */}
                </GalleryGrid>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12">
                    {/* Left Column - Details */}
                    <div className="lg:col-span-2">
                        {/* Host Info */}
                        {/* <HostSection>
                            <HostInfo>
                                <div>
                                    <HostName>
                                        Entire rental unit managed by{" "}
                                        <span className="text-primary-color">
                                            {capitalizeFirstLetter(apiData?.name || "")}
                                        </span>
                                    </HostName>
                                    <div className="flex items-center gap-1 mt-1">
                                        <span className="text-xs sm:text-sm text-gray-600">
                                            {inventoryBelongsTo[apiData?.belongsToId] || ""}
                                        </span>
                                    </div>
                                </div>
                            </HostInfo>
                        </HostSection> */}

                        {/* Rental Terms Section */}

                        <Section className="pb-6">

                            {/* Header */}
                            <div className="mb-4">
                                <SectionTitle>Rental Terms</SectionTitle>
                                <p className="text-sm text-gray-500 mt-1">
                                    Policies and conditions for renting this property
                                </p>
                            </div>

                            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">

                                {[
                                    {
                                        icon: FaCalendarAlt,
                                        label: "Agreement",
                                        value: apiData?.agreementPeriod
                                            ? `${apiData.agreementPeriod} Months`
                                            : "Flexible",
                                    },
                                    {
                                        icon: FaLock,
                                        label: "Lock-in",
                                        value: apiData?.lockInPeriod
                                            ? `${apiData.lockInPeriod} Months`
                                            : "No Lock-in",
                                    },
                                    {
                                        icon: FaClock,
                                        label: "Notice",
                                        value: apiData?.noticePeriod
                                            ? `${apiData.noticePeriod} Months`
                                            : "Standard",
                                    },
                                    {
                                        icon: FaVenusMars,
                                        label: "Tenant",
                                        value:
                                            tenantPreferenceMap[apiData?.tenantPreference] || "Any",
                                    },
                                    // {
                                    //     icon: FaUtensils,
                                    //     label: "Food",
                                    //     value:
                                    //         foodPreferenceMap[apiData?.foodPreference] || "Any",
                                    // },
                                    {
                                        icon: FaInfoCircle,
                                        label: "Visitors",
                                        value: apiData?.visitorPolicy || "Allowed",
                                    },
                                ].map((item, idx) => {
                                    const Icon = item.icon;

                                    return (
                                        <div
                                            key={idx}
                                            className="
                                                flex items-start gap-3 
                                                p-4 rounded-xl 
                                                bg-white 
                                                border border-gray-100 
                                                shadow-sm hover:shadow-md 
                                                transition-all duration-200
                                            "
                                        >
                                            {/* Icon */}
                                            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-color/10 text-primary-color">
                                                <Icon className="w-4 h-4" />
                                            </div>

                                            {/* Content */}
                                            <div>
                                                <p className="text-xs text-gray-400 tracking-wide">
                                                    {item.label}
                                                </p>
                                                <p className="text-sm font-semibold text-gray-800 mt-0.5">
                                                    {item.value}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </Section>

                        {/* Property Overview Section */}
                        <Section>
                            <div className="mb-4">
                                <SectionTitle>Property Overview</SectionTitle>
                                <p className="text-sm text-gray-500 mt-1">
                                    Key rules and preferences for this property
                                </p>
                            </div>

                            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4">

                                {overviewItems
                                    .filter(item => item.value && item.value !== "Not specified")
                                    .map((item, idx) => {
                                        const Icon = item.icon;

                                        return (
                                            <div
                                                key={idx}
                                                className="
                                                flex items-start gap-3 
                                                p-4 rounded-xl 
                                                bg-white 
                                                border border-gray-100 
                                                shadow-sm hover:shadow-md hover:-translate-y-[1px]
                                                transition-all duration-200
                                            "
                                            >
                                                {/* Icon */}
                                                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-color/10 text-primary-color">
                                                    <Icon className="w-4 h-4" />
                                                </div>

                                                {/* Content */}
                                                <div className="flex flex-col">
                                                    <span className="text-xs text-gray-400 tracking-wide">
                                                        {item.label}
                                                    </span>
                                                    <span className="text-sm font-semibold text-gray-800 mt-0.5">
                                                        {item.value}
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>

                        </Section>

                        {/* <Section className="border-b">
                            <SectionTitle>Rental Terms</SectionTitle>

                            <TermsGrid>
                                {[
                                    // {
                                    //     icon: FaCalendarAlt,
                                    //     label: "Agreement Period",
                                    //     value: propertyData.agreementPeriod,
                                    // },
                                    // {
                                    //     icon: FaClock,
                                    //     label: "Notice Period",
                                    //     value: propertyData.noticePeriod,
                                    // },
                                    // {
                                    //     icon: FaLock,
                                    //     label: "Lock-in Period",
                                    //     value: propertyData.lockinPeriod,
                                    // },
                                    {
                                        icon: FaUtensils,
                                        label: "Food Preference",
                                        value: foodPreferenceMap[apiData?.foodPreference] || "",
                                    },
                                    {
                                        icon: FaCouch,
                                        label: "Furnishing",
                                        value: furnishingTypeMap[apiData?.furnishingType] || "",
                                    },
                                    {
                                        icon: FaBuilding,
                                        label: "Inventory Type",
                                        value: inventoryTypeMap[apiData?.inventoryType] || "",
                                    },
                                    {
                                        icon: FaVenusMars,
                                        label: "Tenant Preference",
                                        value: tenantPreferenceMap[apiData?.tenantPreference] || "Not Specified",
                                    },
                                ].map((item, idx) => {
                                    const Icon = item.icon;
                                    return (
                                        <TermCard key={idx}>
                                            <IconWrapper>
                                                <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
                                            </IconWrapper>

                                            <div>
                                                <p className="text-xs sm:text-sm text-gray-500">
                                                    {item.label}
                                                </p>
                                                <p className="text-sm sm:text-base font-semibold text-gray-800">
                                                    {item.value}
                                                </p>
                                            </div>
                                        </TermCard>
                                    );
                                })}
                            </TermsGrid>
                        </Section> */}

                        {/* <Section className="border-b mt-6">
                            <SectionTitle>Inventory Details</SectionTitle>

                            <TermsGrid>
                                {propertyDetailsMap.map((item, idx) => (
                                    <TermCard key={idx}>
                                        <div>
                                            <p className="text-xs sm:text-sm text-gray-500">{item.label}</p>
                                            <p className="text-sm sm:text-base font-semibold text-gray-800">
                                                {item.value}
                                            </p>
                                        </div>
                                    </TermCard>
                                ))}
                            </TermsGrid>
                        </Section> */}

                        <Section className="pb-6">
                            {/* Header */}
                            <div className="mb-4">
                                <SectionTitle>Features & Amenities</SectionTitle>
                                <p className="text-sm text-gray-500 mt-1">
                                    What this property offers
                                </p>
                            </div>

                            {/* Features Grid */}
                            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-3">

                                {apiData?.features ?
                                    (apiData.features
                                        .split(",")
                                        .map((id) => PROPERTY_FEATURES[id.trim()])
                                        .filter(Boolean)
                                        .map((feature, idx) => (
                                            <div
                                                key={idx}
                                                className="
                                                flex items-center gap-2 
                                                px-3 py-2 
                                                bg-white 
                                                border border-gray-100 
                                                rounded-xl 
                                                shadow-sm hover:shadow-md 
                                                transition-all duration-200
                                                "
                                            >
                                                {/* Icon */}
                                                <div className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-color/10 text-primary-color text-xs">
                                                    ✓
                                                </div>

                                                {/* Text */}
                                                <span className="text-sm font-medium text-gray-800">
                                                    {feature}
                                                </span>
                                            </div>
                                        )))
                                    :
                                    (
                                        <div className="col-span-full text-center py-6 border border-dashed border-gray-200 rounded-xl bg-gray-50">
                                            <p className="text-sm text-gray-500">
                                                No features & amenities available for this property
                                            </p>
                                        </div>
                                    )
                                }
                            </div>

                        </Section>

                        {/* <Section className="border-b mt-6">
                            <SectionTitle>Inventory Features</SectionTitle>
                            <div className="flex flex-wrap gap-2 mt-2">
                                {apiData?.features &&
                                    apiData.features
                                        .split(",") // assuming features come as comma-separated IDs
                                        .map((id) => PROPERTY_FEATURES[id.trim()])
                                        .filter(Boolean)
                                        .map((feature, idx) => (
                                            <span
                                                key={idx}
                                                className="px-3 py-1 text-xs sm:text-sm bg-gray-100 rounded-lg font-medium text-gray-800"
                                            >
                                                {feature}
                                            </span>
                                        ))}
                            </div>
                        </Section> */}


                        {/* Amenities */}
                        {/* <Section>
                            <SectionTitle>What this place offers</SectionTitle>
                            <AmenitiesGrid>
                                {propertyData.amenities.map((item, idx) => (
                                    <div key={idx} className="flex items-center gap-2 sm:gap-3">
                                        <item.icon className="w-4 h-4 sm:w-5 sm:h-5 text-gray-700" />
                                        <span className="text-sm sm:text-base text-gray-700">
                                            {item.name}
                                        </span>
                                    </div>
                                ))}
                            </AmenitiesGrid>
                        </Section> */}
                    </div>

                    {/* Right Column - Booking Card */}
                    {/* RIGHT - PRICING */}
                    <div className="lg:col-span-1">
                        <PricingCard>

                            <div className="text-2xl font-bold">
                                ₹{Number(apiData?.amount).toLocaleString()}
                                <span className="text-sm text-gray-500"> / month</span>
                            </div>

                            <div className="bg-gray-50 rounded-xl p-4 mt-4 space-y-3">
                                <PriceRow label="Deposit" value={apiData?.deposit} />
                                <PriceRow label="Maintenance" value={apiData?.maintenance} />
                                <PriceRow label="Move-In" value={apiData?.moveInCharges} />

                                <div className="border-t pt-3 flex justify-between font-semibold">
                                    <span>Total</span>
                                    <span className="text-primary-color">
                                        ₹{totalMoveIn.toLocaleString()}
                                    </span>
                                </div>
                            </div>

                            <div className="mt-5 flex gap-3">
                                <CTAButton
                                    onClick={() =>
                                        (window.location.href = `tel:${apiData?.postedByNumber}`)
                                    }
                                >
                                    <FaPhone /> Call
                                </CTAButton>

                                <WhatsAppButton
                                    onClick={() =>
                                        window.open(`https://wa.me/${apiData?.postedByNumber}`)
                                    }
                                >
                                    <FaWhatsapp /> WhatsApp
                                </WhatsAppButton>
                            </div>

                        </PricingCard>
                    </div>
                </div>
                {/* <AirbnbMapSection data={propertyData} /> */}
            </Main>

            <Footer>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">

                    {/* Top Section */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

                        {/* Brand */}
                        <div>
                            <img src={Images.Logo} alt="Kipinn" className="w-24 mb-3" />
                            <p className="text-sm text-gray-500 leading-relaxed">
                                Discover verified rental properties with transparent pricing and seamless experience on Kipinn.
                            </p>
                        </div>

                        {/* Property Info */}
                        <div>
                            <h4 className="text-sm font-semibold text-gray-800 mb-3">
                                Property Info
                            </h4>
                            <div className="space-y-2 text-sm text-gray-600">
                                <p><strong>Name:</strong> {capitalizeFirstLetter(apiData?.inventoryName || "")}</p>
                                <p><strong>Location:</strong> {capitalizeFirstLetter(apiData?.address || "")}</p>
                                <p><strong>Type:</strong> {inventoryTypeMap[apiData?.inventoryType] || "N/A"}</p>
                            </div>
                        </div>

                        {/* Contact */}
                        <div className="hidden md:block">
                            <h4 className="text-sm font-semibold text-gray-800 mb-3">
                                Contact
                            </h4>
                            <div className="space-y-3">

                                <button
                                    onClick={() => window.location.href = `tel:${apiData?.postedByNumber}`}
                                    className="w-full flex items-center justify-center gap-2 bg-primary-color text-white py-2 rounded-lg font-medium"
                                >
                                    <FaPhone /> Call Owner
                                </button>

                                <button
                                    onClick={() => window.open(`https://wa.me/${apiData?.postedByNumber}`)}
                                    className="w-full flex items-center justify-center gap-2 bg-green-500 text-white py-2 rounded-lg font-medium"
                                >
                                    <FaWhatsapp /> WhatsApp
                                </button>

                            </div>
                        </div>

                    </div>

                    {/* Divider */}
                    <div className="border-t mt-8 pt-4 text-center text-xs text-gray-400">
                        © {new Date().getFullYear()} Kipinn. All rights reserved.
                    </div>

                </div>

            </Footer>

            {showAllPhotos && <FullScreenModal />}
        </Container>
    );
};


// ==================== STYLED COMPONENTS ====================

const Container = tw.div`min-h-screen bg-white`;
//const Header = tw.header`border-b sticky top-0 bg-white z-40 shadow-sm`;
const Header = tw.header`
  sticky top-0 z-50 
  bg-white/80 backdrop-blur-lg 
  border-b border-gray-100
`;
//const HeaderContainer = tw.div`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between`;
const HeaderContainer = tw.div`
  max-w-7xl mx-auto 
  px-4 sm:px-6 lg:px-8 
  py-3 
  flex items-center justify-between
`;
const Logo = tw.img`w-16 sm:w-20`;
// const HeaderActions = tw.div`
//   flex items-center gap-2 sm:gap-3
// `;
const HeaderActions = tw.div`
  flex items-center gap-2 sm:gap-3
`;
const WhatsAppHeaderBtn = tw.button`
  flex items-center gap-1 sm:gap-2
  bg-green-500 hover:bg-green-400
  text-white px-3 sm:px-4 py-2
  rounded-lg font-medium text-xs sm:text-sm
  transition-all duration-300 shadow-sm
`;

const CallHeaderBtn = tw.button`
  flex items-center gap-1 sm:gap-2
  bg-primary-color hover:bg-hover-color
  text-white px-3 sm:px-4 py-2
  rounded-lg font-medium text-xs sm:text-sm
  transition-all duration-300 shadow-sm
`;
const Main = tw.main`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6`;
const Title = tw.h1`text-xl sm:text-2xl md:text-3xl font-semibold leading-tight`;
const LocationText = tw.span`text-sm`;
//const GalleryGrid = tw.div`grid grid-cols-2 sm:grid-cols-4 gap-1 sm:h-80 md:h-96 rounded-xl overflow-hidden mb-6 sm:mb-8`;
const GalleryGrid = tw.div`
  grid grid-cols-2 sm:grid-cols-4 gap-1
  min-h-[220px] sm:h-80 md:h-96
  rounded-xl overflow-hidden mb-4 sm:mb-8
`;
const MainImageContainer = tw.div`col-span-2 row-span-2`;
const GalleryImage = tw.img`w-full h-full object-cover cursor-pointer hover:opacity-95 transition-opacity`;
const ShowAllPhotosButton = tw.button`absolute bottom-3 lg:bottom-8 right-3 bg-white rounded-lg px-3 py-1.5 text-xs font-semibold flex items-center gap-2 shadow-md hover:bg-gray-100 transition-colors z-10`;
// Section Components
const Section = tw.section`py-5 sm:py-7`;
const SectionTitle = tw.h3`text-lg sm:text-xl font-semibold mb-4 relative inline-block after:content-[''] after:block after:h-[3px] after:w-12 after:bg-gradient-to-r after:from-primary-color after:to-blue-400 after:mt-1 after:rounded-full`;
const ModalOverlay = tw.div`fixed inset-0 bg-black/95 z-50 flex items-center justify-center`;
const CloseButton = tw.button`absolute top-4 right-4 z-50 text-white hover:text-gray-300 transition-colors bg-black/50 rounded-full p-2`;
const ModalContent = tw.div`w-full h-full flex flex-col items-center justify-center p-4`;
const ImageContainer = tw.div`relative flex items-center justify-center w-full h-[50vh] sm:h-[60vh] md:h-[70vh]`;
const FullScreenImage = tw.img`max-w-full max-h-full object-contain`;
const NavButton = tw.button`absolute top-1/2 -translate-y-1/2 bg-black/50 text-white rounded-full p-2 sm:p-3 hover:bg-black/70 transition-all z-10`;
const ImageCounter = tw.div`absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm`;
const ThumbnailStrip = tw.div`flex gap-2 sm:gap-3 mt-4 sm:mt-6 overflow-x-auto pb-2 max-w-[90vw]`;
const ThumbnailButton = tw.button`flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 rounded-lg overflow-hidden border-2 transition-all`;

const PricingCard = tw.div`
  sticky top-24 
  bg-white rounded-2xl 
  border border-gray-100 
  shadow-lg p-5
`;

const CTAButton = tw.button`
  w-1/2 bg-primary-color text-white py-2.5 rounded-xl font-semibold flex items-center justify-center gap-2
`;

const WhatsAppButton = tw.button`
  w-1/2 bg-green-500 text-white py-2.5 rounded-xl font-semibold flex items-center justify-center gap-2
`;

const PriceRow = ({ label, value }) => (
    <div className="flex justify-between text-sm">
        <span className="text-gray-500">{label}</span>
        <span className="font-medium">
            ₹{Number(value || 0).toLocaleString()}
        </span>
    </div>
);

const Footer = tw.footer`
  bg-white 
  border-t border-gray-100 
  mt-10
`;
export default PropertyDetail;